// extracted by mini-css-extract-plugin
export default {"chooserButton":"ModulChooserButton_chooserButton__b2FNo"};